export default {
    setCurrentUser(state, data) {
        state.currentUser = data;
        state.loading = false;
    },
    setLoading(state, data) {
        state.loading = data;
    },
}